import Login from "../components/pages/login/LoginPage";
import ResetPasswordPage from "../components/pages/login/ResetPasswordPage";
import EmptyPage from "../components/pages/generic/EmptyPage";
import Page404 from "../components/pages/generic/Page404";
import ApiPage from "../components/pages/apiPage/ApiPage";

const routes = [
    {
        path: "/*",
        element: <Page404 />
    },
    {
        path: "/",
        element: <EmptyPage />
    },
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/login/:inviteID",
        element: <Login />
    },
    {
        path: "/resetpassword",
        element: <ResetPasswordPage />
    },
    {
        path: "/:resource/api/:action",
        element: <ApiPage />
    }
];

export default routes;
